import { render } from "./A4.vue?vue&type=template&id=36232d69&scoped=true"
import script from "./A4.vue?vue&type=script&lang=js"
export * from "./A4.vue?vue&type=script&lang=js"

import "./A4.vue?vue&type=style&index=0&id=36232d69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36232d69"]])

export default __exports__